import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import EntityBottomPanel from '../../ui/entity/EntityBottomPanel'
import EntityBottomPanelBtn from '../../ui/entity/EntityBottomPanelBtn'
import UIMessages from 'src/utils/ui-messages'
import { Button } from '@mobiscroll/react-latest'

interface IStationUserBottomPanelProps {
  completed?: boolean
  isLoading?: boolean
  processing?: boolean
  fetching?: boolean
  onCancelClick: () => void
  onSubmitClick: () => void
}

const StationUserBottomPanel = ({
  completed,
  isLoading = false,
  fetching,
  processing,
  onCancelClick,
  onSubmitClick
}: IStationUserBottomPanelProps) => {
  const { cancel, save } = UIMessages.common

  return (
    <div className='flex absolute bottom-0 flex items-center justify-end bg-light-grey7 px2 py1 w100 z1'>
      <div className='flex justify-end pr3 w100'>
        <Button ariaLabel='Cancel button' className='mbsc-flat-white-btn' disabled={isLoading} onClick={onCancelClick}>
          {cancel}
        </Button>
        <Button ariaLabel='Save button' className='mbsc-success-btn' disabled={isLoading} onClick={onSubmitClick}>
          {save}
        </Button>
      </div>
    </div>
  )
}

export default StationUserBottomPanel



// WEBPACK FOOTER //
// ./src/components/station-user/form/StationUserBottomPanel.tsx